import React, { PureComponent } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { isLogin } from "store/selectors/loginState";
import SourceForm from "./iSourceForm";
import { actISourceFormInit, actISourceCreateRequest } from "./actions";
import { actLoginInit, actLogin } from "../Login/actions";

class iSourceContainer extends PureComponent {
    render() {
        return <SourceForm {...this.props} />;
    }
}

const mapStateToProps = (state, { cookies }) => ({
    isUserLogin: isLogin(state) && !!cookies.get("token"),
    profile: state.loginState.profile,
    iSourceStatus: state.iSource && state.iSource.status,
    loginState: state.loginState
});

const mapDispatchToProps = dispatch => ({
    onInit: bindActionCreators(actLoginInit, dispatch),
    onFormInit: bindActionCreators(actISourceFormInit, dispatch),
    onSubmit: bindActionCreators(actISourceCreateRequest, dispatch),
    onLogin: bindActionCreators(actLogin, dispatch)
});

iSourceContainer.propTypes = {
    profile: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withCookies(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(iSourceContainer))
);
